import { Frequency, RRule } from "rrule";

type Recurrence = {
  freq: Frequency;
  interval: number;
  count: number | null;
  until: Date | null;
};

const makeRule = (options: Recurrence): RRule => {
  return new RRule(options);
};

export { type Recurrence, makeRule };
